<template>
  <div
    class="dropdown-container"
    :style="{ justifyContent: align === 'right' ? 'flex-end' : 'flex-start' }"
  >
    <div class="quote" v-if="quote" v-html="quote"></div>
    <div
      v-click-outside="close"
      :class="['tva-dropdown', dropdownOpen ? 'open' : '']"
      :style="{
        width: width && width.length ? width : defaultWidth + 'px',
        height: dropdownOpen
          ? itemHeight + itemHeight * list.length + 'px'
          : itemHeight + 'px',
        marginTop: dropdownOpen
          ? -itemHeight * list.length - 5 + 'px'
          : -5 + 'px',
        transform: dropdownOpen
          ? `translateY(${itemHeight * list.length}px)`
          : `translateY(0)`,
        maxHeight: maxHeight + itemHeight + 'px'
      }"
    >
      <div
        :class="['tva-dropdown-button']"
        @click="dropdownOpen = !dropdownOpen"
      >
        <span>{{ selectedEl }}</span>
        <svgicon
          class="actions-navigation-chevron-down"
          icon="actions-navigation-chevron-down"
          width="18"
          height="18"
        ></svgicon>
      </div>

      <transition name="slide">
        <ul
          v-show="dropdownOpen"
          :style="{
            height: itemHeight * list.length + 'px',
            maxHeight: maxHeight + 'px'
          }"
        >
          <li
            v-for="(child, childIndex) in computedList"
            @click="selectElement(child)"
            :key="childIndex"
            :class="{ selected: child.label === selectedEl }"
          >
            {{ child.label }}
          </li>
        </ul>
      </transition>
    </div>
  </div>
</template>
<script>
import "@/compiled-icons/actions-navigation-chevron-down";
import ClickOutside from "vue-click-outside";

export default {
  props: [
    "content",
    "quote",
    "placeholder",
    "selectedElement",
    "align",
    "maxHeightFixed",
    "width"
  ],
  data() {
    return {
      selectedEl: this.selectedElement,
      dropdownOpen: false,
      itemHeight: 40,
      defaultWidth: 200
    };
  },
  methods: {
    selectElement(element) {
      // this.content.forEach((el, i) => {
      //   el.active = false;
      //   if (i === index) {
      //     el.active = true;
      //   }
      // });

      this.$emit("click", this.content);
      this.selectedEl = element.label;
      this.dropdownOpen = false;
    },
    close() {
      this.dropdownOpen = false;
    }
  },
  watch: {
    selectedElement(selectedElement) {
      this.selectedEl = selectedElement;
    }
  },
  directives: {
    ClickOutside
  },
  computed: {
    maxHeight() {
      if (this.maxHeightFixed >= 0) {
        return this.maxHeightFixed;
      } else {
        return this.$tvaMq !== "mobile" ? 400 : 250;
      }
    },
    computedList() {
      return this.list.sort((a, b) => {
        return b.label - a.label;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.dropdown-container {
  display: flex;
  height: 35px;
  z-index: 1;
  .quote {
    margin-right: 1em;
    color: $primary;
    font-family: "Roboto", sans-serif;
    font-size: 16px;
  }
  .tva-dropdown {
    box-sizing: border-box;
    position: relative;
    margin-top: -4px;
    display: inline-block;
    color: $primary;
    border: solid 1px $primary;
    background-color: white;
    transition: height 0.4s ease;
    z-index: 100;
    cursor: pointer;
    height: 50px;
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    font-weight: 500;
    &.open {
      overflow: hidden;
      .tva-dropdown-button {
        &::after {
          opacity: 1;
        }
      }
      ul {
        overflow-y: scroll;
        width: 110%;
      }
    }

    .tva-dropdown-button {
      cursor: pointer;
      padding: 3px 38px 1px 8px !important;
      white-space: nowrap;
      display: flex;
      align-items: center;
      height: 40px;
      text-transform: capitalize;
      position: relative;
      &::after {
        opacity: 0;
        transition: opacity 0.7s ease 0.2s;
        content: "";
        position: absolute;
        bottom: -7px;
        left: 0;
        height: 7px;
        width: 100%;
        background: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0));
      }
      &:hover {
        background: rgba($secondary, 0.5);
        color: $primary;
      }
      .arrow {
        position: absolute;
        right: 20px;
        top: 10px;
        transform: rotate(90deg);
        fill: $primary;
      }
    }
    .slide-enter,
    .slide-leave-to {
      opacity: 0;
      transform: translateY(-20px);
      height: 0;
    }
    .slide-enter-active {
      transition-delay: 0.3s;
    }
    .slide-leave-active {
      transition: all 0s ease;
    }
    ul {
      transition: all 0.4s ease;
      list-style-type: none;
      padding: 0;
      margin: 0;
      li {
        cursor: pointer;
        padding: 3px 8px;
        white-space: nowrap;
        height: 40px;
        display: flex;
        align-items: center;
        text-transform: capitalize;
        &:hover,
        &.selected {
          background: rgba($secondary, 0.5);
          color: $primary;
        }
      }
    }
  }
}
</style>
